module.exports = __webpack_public_path__ + "static/media/del_btn.16952e74.svg";